import { jsx as _jsx } from "react/jsx-runtime";
import { Skeleton, Typography } from '@mui/material';
const ProductTitle = ({ title, variant = 'h6', maxLines, fontSize, onClick, sx = {}, isLoading, }) => {
    const titleStyles = {
        cursor: onClick ? 'pointer' : 'default',
        fontWeight: 700,
        lineHeight: 1.25,
        paddingTop: '0.25rem',
        ...(fontSize && { fontSize }),
        ...(maxLines && {
            display: '-webkit-box',
            WebkitLineClamp: maxLines,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
        }),
        ...sx,
    };
    return (_jsx(Typography, { variant: variant, sx: titleStyles, onClick: onClick, children: (!title && isLoading) ? _jsx(Skeleton, { variant: "text", width: "100%" }) : title }));
};
ProductTitle.defaultProps = {
    variant: undefined,
    maxLines: undefined,
    fontSize: undefined,
    onClick: undefined,
    sx: {},
};
export default ProductTitle;
//# sourceMappingURL=ProductTitle.js.map